import React, {FC} from 'react';
import styled from 'styled-components';
import {COLORS} from '../../../../../constants/colors';
import {FONT_SIZES, FONT_WEIGHTS} from '../../../../../constants/typography';
import {SortingOption} from '../../types/SortingOption';

interface Props {
  activeOptionId?: string;
  dataTestId?: string;
  onSelect: (optionId: string) => void;
  options: Array<SortingOption>;
  Wrapper?: React.ComponentType<React.PropsWithChildren>;
}

export const FilterSingleSelectOptions: FC<Props> = ({
  activeOptionId,
  dataTestId = 'filterSingleSelectOptions',
  onSelect,
  options,
  Wrapper = React.Fragment,
  ...props
}) => {
  return (
    <Section data-testid={dataTestId} {...props}>
      <Wrapper>
        {options.map(option => (
          <SelectButton
            active={Boolean(activeOptionId && option.id === activeOptionId)}
            data-testid={`${dataTestId}-${option.id}`}
            key={`${dataTestId}-${option.id}`}
            onClick={() => onSelect(option.id)}
          >
            {option.label}
          </SelectButton>
        ))}
      </Wrapper>
    </Section>
  );
};

const Section = styled.section``;

const SelectButton = styled.button<{active?: boolean}>`
  box-sizing: border-box;
  height: 38px;
  padding: 0 0.875rem;
  border: ${({active}) =>
    active ? `2px solid ${COLORS.Black}` : `2px solid ${COLORS.Grey5}`};
  border-radius: 2px;
  margin: 0 0.625rem 0.625rem 0;
  background-color: ${({active}) => (active ? COLORS.White : COLORS.Grey5)};
  color: ${COLORS.Black};
  font-size: ${FONT_SIZES.px12};
  font-weight: ${FONT_WEIGHTS.bold};
  cursor: pointer;
  transition: 0.15s;
  flex-shrink: 0;

  &:focus {
    outline: none;
  }

  &:hover {
    background-color: ${({active}) => (active ? COLORS.White : COLORS.Grey4)};
    border-color: ${({active}) => (active ? COLORS.Black : COLORS.Grey4)};
  }
`;
